import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import StyledSmallTitle from "../styled/styledSmallTitle"
import { StyledTitle } from "../Title"
import { StyledButton } from "../Button"
import PersonCards from "./PersonCards"
import logoBg from "../../images/logo/logoBg.svg"

const StyledSection = styled(BackgroundImage)`
  background-position: top top;
  position: relative;
  z-index: 10;
  @media (min-width: 768px) {
    background-size: contain;
    height: 695px;
    display: flex;
    align-items: flex-end;
  }
`

const ExtendStyledTitle = styled(StyledTitle)`
  &.section-title {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.75);
    font-family: "Made Medium", sans-serif;
    font-size: 20px;
    letter-spacing: 0.5px;
    &::after {
      left: 50%;
      transform: translateX(-50%);
      background-color: #f9d6c1;
    }
    @media (min-width: 768px) {
      margin-bottom: 86px;
      font-size: 32px;
    }
  }
  &.banner-title {
    margin-bottom: 16px;
    &::after {
      display: none;
    }
    @media (min-width: 1024px) {
      margin-bottom: 50px;
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 1px;
      padding-bottom: 0;
    }
  }
`

const Container = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, minmax(auto, 270px));
    grid-column-gap: 25px;
    justify-content: center;
  }
  @media (min-width: 1024px) {
    grid-column-gap: 50px;
  }
`

const Box = styled.div`
  padding: 32px 16px 0;
  &::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 100px;
    background-color: #fffcfa;
    z-index: -1;
  }
  @media (min-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`

const CustomContactButton = styled(StyledButton)`
  background-color: #fff;
  color: #000;
  width: 100%;
  text-decoration: none;
  @media (min-width: 768px) {
    width: 270px;
  }
`

const ContactBanner = styled.aside`
  margin-top: -100%;
  background-color: #474dc4;
  width: 100vw;
  height: 307px;
  background-image: url(${logoBg});
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (min-width: 768px) {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(0, -50%);
    z-index: 50;
    width: 90vw;
    border-radius: 8px 0 0 8px;
    margin-top: 0;
  }
  @media (min-width: 1024px) {
    background-size: 40%;
    height: 370px;
    padding: 0 16px 0 0;
    justify-content: center;
  }
  @media (min-width: 1200px) {
    width: 90vw;
  }
`

const BannerContainer = styled.div`
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (min-width: 768px) {
    padding: 64px 32px;
  }
  @media (min-width: 1024px) {
    padding: 64px 0;
  }
`

const Team = () => {
  const { bgTeam } = useStaticQuery(graphql`
    query {
      bgTeam: file(relativePath: { eq: "teamBg.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <StyledSection Tag="section" fluid={bgTeam.childImageSharp.fluid}>
      <ContactBanner>
        <BannerContainer>
          <ExtendStyledTitle light center className="banner-title">
            <span>Wypełnij krótki formularz - otrzymasz 3 różne oferty.</span>{" "}
            <br />
            Do wyboru, do koloru.
          </ExtendStyledTitle>
          <CustomContactButton as={AnchorLink} to="/#kontakt">
            Zatrudnij nas
          </CustomContactButton>
        </BannerContainer>
      </ContactBanner>
      <Box>
        <StyledSmallTitle
          style={{
            textAlign: "center",
            color: "#f9d6c1",
            textShadow: "0 1px 2px rgba(0, 0, 0, 0.75)",
          }}
        >
          DRUŻYNA
        </StyledSmallTitle>
        <ExtendStyledTitle light center className="section-title">
          <span>Poznaj nas bliżej.</span>
        </ExtendStyledTitle>
        <Container>
          <PersonCards />
        </Container>
      </Box>
    </StyledSection>
  )
}

export default Team
